// extracted by mini-css-extract-plugin
module.exports = {"box":"box-1kHdScFH clearfix"};